/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Sugg_DismissInputs */

const cs_addr_sugg_dismiss = /** @type {(inputs: Addr_Sugg_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamítnout`)
};

const en_addr_sugg_dismiss = /** @type {(inputs: Addr_Sugg_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Addr_Sugg_DismissInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_sugg_dismiss = /** @type {((inputs?: Addr_Sugg_DismissInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Sugg_DismissInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_sugg_dismiss(inputs)
	return cs_addr_sugg_dismiss(inputs)
});